<template>
    <div style="position: absolute; left: 16px; bottom: 8px;">
        <v-row class="ma-n4">
            <v-col class="pa-4" cols="auto">
                <v-dialog v-model="shows" max-width="320" content-class="fill-height">
                    <template #activator="{ attrs, on }">
                        <v-btn icon color="white" class="primary" v-bind="attrs" v-on="on">
                            <v-icon> mdi-view-list </v-icon>
                        </v-btn>
                    </template>
                    <v-card class="fill-height">
                        <desc-list v-model="form" mobile v-on="{ exit }" @input="emit" />
                    </v-card>
                </v-dialog>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { initEmploymentForm } from "@/assets/variables";

import DescList from "./desc/desc-list.vue";

export default {
    components: {
        DescList,
    },
    props: {
        value: { type: Object, default: initEmploymentForm },
    },
    data: () => ({
        form: initEmploymentForm(),

        shows: false,
    }),
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.form = initEmploymentForm(this.value);
        },
        emit() {
            this.$emit("input", this.form);
        },
        exit() {
            this.shows = false;
        },
    },
};
</script>

<style></style>
